import { render, staticRenderFns } from "./WorkingUnsolvedExportIssue.vue?vue&type=template&id=7a5d61c1"
import script from "./WorkingUnsolvedExportIssue.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolvedExportIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5d61c1')) {
      api.createRecord('7a5d61c1', component.options)
    } else {
      api.reload('7a5d61c1', component.options)
    }
    module.hot.accept("./WorkingUnsolvedExportIssue.vue?vue&type=template&id=7a5d61c1", function () {
      api.rerender('7a5d61c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolvedExportIssue.vue"
export default component.exports